import React, {Fragment} from "react";
import ContainerFotoArchivio from "../ContainerFotoArchivio";
import ModalAddMarcaArchivio from "./ModalAddMarcaArchivio";

export default function ContenutoMarcheArchivioView({
                                                        marche,
                                                        isRuoloAd,
                                                        openModalAddMarca,
                                                        closeModalAddMarca,
                                                        addMarcaOk,
                                                        showModalAddMarca,
                                                        selectMarca,
                                                        tipoVeicolo,
                                                    }) {

    return (
        <Fragment>
            <ModalAddMarcaArchivio
                show={showModalAddMarca}
                handleClose={closeModalAddMarca}
                submitOk={addMarcaOk}
                tipoVeicolo={tipoVeicolo}
            />
            <div className="row g-3">
                {
                    !isRuoloAd && marche.length === 0 &&
                    <h5>Nessuna marca presente</h5>
                }
                {
                    isRuoloAd &&
                    <div className={"col-md-3"}>
                        <div
                            className={"ns-container-foto-upl ns-cursor-pointer ns-hover-shadow"}
                            onClick={openModalAddMarca}
                        >
                            <div className={"ns-container-foto-archivio-label text-center"}>
                                <span aria-hidden="true">
                                    <div style={{
                                        height: "66px"
                                    }}>
                                        <h6>Aggiungi</h6>
                                    </div>
                                    <div className={"ns-foto"}>
                                        <div className={"ns-foto-img"}>
                                            <i className="fas fa-plus-circle" style={{fontSize: "6rem"}}></i>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                }
                {
                    marche.map((f, idx) =>
                        <div className={"col-md-3"} key={idx}>
                            <ContainerFotoArchivio
                                idDocumento={f.id_archivio_marca}
                                titolo={f.marca}
                                sottotitolo={f.anno_da || f.anno_a ? `${f.anno_da || ''} - ${f.anno_a || ''}` : ''}
                                nome={f.nome_file}
                                endpointContent={process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/marche/${f.id_archivio_marca}`}
                                handleOnClick={() => {
                                    selectMarca(f);
                                }}
                            />
                        </div>
                    )
                }
            </div>
        </Fragment>
    );
}